import { GetCustomizeCar_customizeCar_availableFeatures as Feature } from '../graphql/queries/__generated__/GetCustomizeCar';

const availableFeatureService = {
  getFeature: (feature: Feature) => {
    return {
      name: feature.label,
      code: feature.code,
      categoryCode: feature.categoryCode,
      shortDescription: feature.shortDescription,
      longDescription: feature.longDescription,
      images: feature.images,
      prices: feature.prices,
      attributes: feature.attributes,
    };
  },
};

export default availableFeatureService;
